export function updateDate(date, options) {
  const { addDays, addMonths, addYears } = options || {}
  date = new Date(date)

  if (addDays) {
    date.setDate(date.getDate() + addDays)
  }
  if (addMonths) {
    date.setMonth(date.getMonth() + addMonths)
  }
  if (addYears) {
    date.setFullYear(date.getFullYear() + addYears)
  }

  return date
}

export function populateAndFormatPlaceholderDate(formatDate, string = '') {
  const placeholderRegex = /{[0-9]*}/g
  const timestampRegex = /\d+/g
  const timestamp = timestampRegex.exec(string)
  if (timestamp && timestamp.length > 0) {
    const formattedDate = formatDate(new Date(parseInt(timestamp[0], 10)), {
      timeZone: 'Etc/UTC'
    })
    return string.replace(placeholderRegex, formattedDate)
  }
  return string
}
